export const defaultStandardCode = 
`
  <Header>
    <LinkFreeStanding 
      size="m"
      icon={{direction: 'right', name: 'download', type:'20'}}
    >
      ITFS CDR SUMMARY
    </LinkFreeStanding>

    <ActionMenu withSeparator>
      <ActionIcon icon="manage-boards" type="navigation" />
      <ActionIcon icon="user" type="navigation" />
      <ActionIcon icon="notifications" type="navigation" />
    </ActionMenu>

    <BillableId
      title="Data Connectivity"
      opts={['Axis Capital', 'option2', 'option3', 'option4']}
      onChange={() => console.warn('Provide a callback to handle onChange')}
    />
  </Header>
`;

export const defaultWithoutLinkCode = 
`
<Grid layout={allowedLayouts.full}>
  <GridBlock modifier={'FullWidth'}>
    <Header className="main-content">

      <ActionMenu>
        <ActionIcon icon="manage-boards" type="navigation" />
        <ActionIcon icon="user" type="navigation" />
        <ActionIcon icon="notifications" type="navigation" />
      </ActionMenu>
    
      <BillableId
        title="Data Connectivity"
        opts={['Axis Capital', 'option2', 'option3', 'option4']}
        onChange={() => console.warn('Provide a callback to handle onChange')}
      />
    </Header>
  </GridBlock>
</Grid>
`;

export const defaultWithoutBillableCode = 
`
<Grid layout={allowedLayouts.full}>
  <GridBlock modifier={'FullWidth'}>
    <Header className="main-content">
      <LinkFreeStanding
        size="m"
        icon={{direction: 'right', name: 'download', type:'20'}}
      >
        ITFS CDR SUMMARY
      </LinkFreeStanding>

      <ActionMenu>
        <ActionIcon icon="manage-boards" type="navigation" />
        <ActionIcon icon="user" type="navigation" />
        <ActionIcon icon="notifications" type="navigation" />
      </ActionMenu>
    </Header>
  </GridBlock>
</Grid>
`;

export const defaultOnlyActionIconsCode = 
`
<Grid layout={allowedLayouts.full}>
  <GridBlock modifier={'FullWidth'}>
    <Header className="main-content">
      <ActionMenu>
        <ActionIcon icon="manage-boards" type="navigation" />
        <ActionIcon icon="user" type="navigation" />
        <ActionIcon icon="notifications" type="navigation" />
      </ActionMenu>
    </Header>
  </GridBlock>
</Grid>
`;

export const statusPageCode = 
`
<Header className="main-content">
  <ActionMenu statusPage>
    <ActionIcon icon="mail" type="20" />
    <ActionIcon icon="print" type="20" />
    <ActionIcon icon="download" type="20" />
  </ActionMenu>
</Header>
`;

export const landingPageCode =
`
<Header className="main-content" mainMenu={mainMenu} smallMenu={smallMenu}>
  <ActionMenu landing>
    <ActionIcon exception icon="user" type="navigation" />
    <ActionIcon exception icon="search" type="navigation" />
  </ActionMenu>
</Header>
`;



// WEBPACK FOOTER //
// ./src/containers/components/Header/constants/headersCode.js